import { FC, useState } from 'react';
import { Button, Col, Row, Typography } from 'antd';
import { TbDatabaseCog, TbDatabasePlus } from 'react-icons/tb';

import AddDataSourceModal from '@/shared/components/modals/ResourceCreationModals/AddDataSourceModal';

// interface AccountIntegrationsProps {}

const AccountIntegrations: FC = ({}): JSX.Element => {
    const [open, setOpen] = useState(false);
    const [activeView, setActiveView] = useState<'add' | 'manage'>('add');

    return (
        <>
            <Typography.Title id='settings-account-general-account-integrations' level={5}>
                Account Integrations
            </Typography.Title>
            <Row align='middle' gutter={[16, 0]}>
                <Col flex='auto'>
                    <Button
                        block
                        onClick={() => {
                            setActiveView('add');
                            setOpen(true);
                        }}
                    >
                        <TbDatabasePlus size='1rem' />
                        Add Data Source
                    </Button>
                </Col>
                <Col flex='auto'>
                    <Button
                        block
                        type='dashed'
                        onClick={() => {
                            setActiveView('manage');
                            setOpen(true);
                        }}
                    >
                        <TbDatabaseCog size='1rem' />
                        Manage Data Sources
                    </Button>
                </Col>
            </Row>
            <AddDataSourceModal open={open} setOpen={setOpen} activeView={activeView} />
        </>
    );
};

export default AccountIntegrations;
